import React from 'react';
import { T } from '../../lib/tokens';

export const SectionHeader = ({ icon: Icon, iconBg, iconColor, title, subtitle, right }) => (
  <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 16 }}>
    <div style={{ width: 28, height: 28, borderRadius: 8, background: iconBg || T.amberLight, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Icon size={14} color={iconColor || T.amber} />
    </div>
    <div style={{ flex: 1 }}>
      <div style={{ fontSize: 12, fontWeight: 600, color: T.text }}>{title}</div>
      {subtitle && <div style={{ fontSize: 11, color: T.textMuted }}>{subtitle}</div>}
    </div>
    {right}
  </div>
);
